/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION EMOTICON COMMENT RECTIONS : STYLES --------------- ++++++++++ */
export default theme => ({
  emoticoncommentreactions: {
    '& .emojipreview': {
      background: '#fff',
      borderRadius: pxToEm(20),
      boxShadow: `0px 1px 7px 0px #00000014`,
      width: 'auto',
      padding: `${pxToEm(4)} ${pxToEm(8)}`
    }
  }
});
